import {PLATFORM, customElement, containerless, useView, bindable} from 'aurelia-framework';
import {GroupViewHeader} from './view-header';
import {isGroupDefaultOrDummy} from '../../../../../services/group/group-service';

@containerless()
@useView(PLATFORM.moduleName('./view-header.html'))
@customElement('view-header-member-directory')
export class GroupDirectoryViewHeader extends GroupViewHeader {

  atDirectory = true;
  @bindable groupData;

  handleLocation() {
    if (!isGroupDefaultOrDummy(this.selectedGroup.id)) {
      this.showDirectory();
    } else {
      this.showApplication();
    }
  }

}
